import { render } from "./PlateToolView.vue?vue&type=template&id=64122927&scoped=true"
import script from "./PlateToolView.vue?vue&type=script&lang=js"
export * from "./PlateToolView.vue?vue&type=script&lang=js"

import "./PlateToolView.vue?vue&type=style&index=0&id=64122927&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64122927"]])

export default __exports__